import React, { memo } from 'react';
import { Row, Col } from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';

const MemoizedFlexSelect = memo(FlexSelect);

/**
 * Um componente para inserção de detalhes de números telefônicos com seleção de DDI opcional
 *
 * @component
 * @param {Object} props - As propriedades do componente
 * @param {Object} props.field - O objeto de configuração do campo
 * @param {string} props.field.name - O nome do campo
 * @param {Object} props.value - O valor atual do campo de telefone
 * @param {string} [props.value.ddi] - O DDI
 */

const PhoneField = ({
  field,
  value,
  handleFieldChange,
  dataOptions,
  isDisabled,
  useBrazilianDDI,
  hasError,
  ...optional
}) => {
  return (
    <Row>
      {!useBrazilianDDI && (
        <Col xs="4">
          <MemoizedFlexSelect
            isClearable
            isDisabled={isDisabled}
            dataOptions={dataOptions}
            value={value?.ddi || ''}
            valueController={(_, ddiValue) =>
              handleFieldChange(field.name, {
                ...value,
                ddi: ddiValue
              })
            }
            fieldName={`${field.name}_ddi`}
            labelName="col"
            valueName="col"
            placeholder="DDI"
            className={hasError ? 'is-invalid' : ''}
            {...optional}
          />
        </Col>
      )}
      <Col>
        <MemoizedFlexSelect
          isClearable
          isDisabled={isDisabled}
          dataOptions={dataOptions}
          value={value?.number || ''}
          valueController={(_, numberValue) =>
            handleFieldChange(field.name, {
              ...value,
              number: numberValue
            })
          }
          fieldName={`${field.name}_number`}
          labelName="col"
          valueName="col"
          placeholder="Número"
          className={hasError ? 'is-invalid' : ''}
          {...optional}
        />
      </Col>
    </Row>
  );
};

export default memo(PhoneField);
